import { Divider, Stack, Typography } from "@mui/material";
import React, { Fragment, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

type AccordionPropsType = {
  clubhousesToShow: any[];
  showClubhouseHandler: () => void;
  showArrow: boolean;
};

const ChAccordion = ({
  clubhousesToShow,
  showClubhouseHandler,
  showArrow,
}: AccordionPropsType) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => {
    showClubhouseHandler();
    setExpanded(!expanded);
  };

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        onClick={toggleExpand}
      >
        <Typography fontWeight="500" variant="subtitle1" gutterBottom>
          clubs i&apos;m a part of
        </Typography>
        {showArrow ? (
          <Stack
            direction="row"
            alignItems="center"
            onClick={toggleExpand}
            sx={{
              cursor: "pointer",
              transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
              transitionTimingFunction: "linear",
              transition: "transform 0.3s",
            }}
            py={1}
          >
            <ExpandMoreIcon fontSize="medium" onClick={toggleExpand} />
          </Stack>
        ) : null}
      </Stack>
      {clubhousesToShow?.map((clubhouse, index) => (
        <Fragment key={clubhouse.channel_url}>
          <Typography
            variant="subtitle2"
            color="secondary"
            fontWeight="400"
            py={1.5}
          >
            {clubhouse.name}
          </Typography>
          {index + 1 !== clubhousesToShow?.length ? <Divider /> : null}
        </Fragment>
      ))}
    </>
  );
};

export default ChAccordion;
